import { connect, ConnectedProps } from "react-redux";

import { HotelBookMobileButton } from "./component";
import { IStoreState } from "../../../../reducers/types";
import { getUserSelectedTravelerId } from "../../reducer";

const mapStateToProps = (state: IStoreState) => {
  return {
    selectedTravelerId: getUserSelectedTravelerId(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type HotelBookMobileButtonConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedHotelBookMobileButton = connector(HotelBookMobileButton);
